// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../generated-types'

import gql from 'graphql-tag'
export type VenueImageGalleryFragment = {
  __typename?: 'Venue'
  id: number
  tour3dUrl?: string | null
  photos?: Array<{ __typename?: 'VenuePhoto'; thumbUrl?: string | null }> | null
}

export const VenueImageGalleryFragmentDoc = gql`
  fragment VenueImageGallery on Venue {
    id
    tour3dUrl
    photos {
      thumbUrl
    }
  }
`
